import Link from 'next/link'
import { FiHeadphones } from 'react-icons/fi'
import config_names from '../config/config_names';
import { DEFAULT_LOCALE, getSiteCopy, localePath, normalizeLocale } from '@/lib/siteI18n';
import { getDesktopCopy } from '@/lib/desktopDictation';

export default function Footer({ locale = DEFAULT_LOCALE }) {
  const activeLocale = normalizeLocale(locale);
  const copy = getSiteCopy(activeLocale).footer;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">
                <FiHeadphones />
              </span>
              {config_names.projectName}
            </div>
            <p>{copy.tagline}</p>
            <div className="social-links"></div>
          </div>

          <div className="footer-links">
            <h4>{copy.product}</h4>
            <ul>
              <li>
                <Link href={localePath('/transcribe', activeLocale)}>{copy.transcribe}</Link>
              </li>
              <li><Link href={localePath('/transcribe/mp3-to-text', activeLocale)}>{({ de: 'MP3 in Text', fr: 'MP3 en texte', en: 'MP3 to text' })[activeLocale]}</Link></li>
              <li>
                <Link href={localePath('/export', activeLocale)}>{copy.exportFormats}</Link>
              </li>
              <li>
                <Link href={localePath('/api', activeLocale)}>{copy.api}</Link>
              </li>
              <li><Link href={localePath('/desktop', activeLocale)} data-analytics-event="desktop_discovery_click" data-analytics-cta-location="footer">{getDesktopCopy(activeLocale).footer}</Link></li>
              <li><Link href="/mcp">MCP</Link></li>
              <li>
                <Link href={localePath('/features', activeLocale)}>{copy.features}</Link>
              </li>
              <li>
                <Link href={localePath('/features/record-tab-audio', activeLocale)}>{copy.recordTab}</Link>
              </li>
              <li>
                <Link href={localePath('/features/youtube-caption-import', activeLocale)}>{copy.youtube}</Link>
              </li>
              <li>
                <Link href={localePath('/#pricing', activeLocale)}>{copy.pricing}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>{copy.resources}</h4>
            <ul>
              <li>
                <Link href={localePath('/compare', activeLocale)}>{copy.compare}</Link>
              </li>
              <li>
                <Link href="/alternatives">{copy.alternatives}</Link>
              </li>
              <li>
                <Link href={localePath('/immediate-transcription', activeLocale)}>{copy.immediate}</Link>
              </li>
              <li>
                <Link href={localePath('/blog', activeLocale)}>{copy.blog}</Link>
              </li>
              <li>
                <Link href={localePath('/faq', activeLocale)}>{copy.faq}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>{copy.company}</h4>
            <ul>
              <li>
                <Link href={localePath('/about', activeLocale)}>{copy.about}</Link>
              </li>
              <li>
                <Link href={localePath('/contact', activeLocale)}>{copy.contact}</Link>
              </li>
              <li>
                <Link href="/affiliate">{copy.affiliate}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>{copy.legal}</h4>
            <ul>
              <li>
                <Link href={localePath('/terms', activeLocale)}>{copy.terms}</Link>
              </li>
              <li>
                <Link href={localePath('/privacy', activeLocale)}>{copy.privacy}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {config_names.projectName} - {copy.rights}</p>
          <p>{copy.madeFor}</p>
        </div>
      </div>
    </footer>
  )
}
